import { api } from "./http-client";
import { API_PATHS } from "../config/api.config";

export type Profile = {
  firstName: string | null;
  lastName: string | null;
  email: string;
  profileIcon: string | null;
  gender: string | null;
};

export const accountService = {
  deleteAccount: async (): Promise<void> => {
    await api.request<{ deleted: boolean }>({ url: API_PATHS.USERS.ME, method: "DELETE" });
  },
  getProfile: async (): Promise<Profile> =>
    (await api.request<Profile>({ url: API_PATHS.USERS.ME, method: "GET" })).data,
  updateProfile: async (fields: Partial<Profile>): Promise<Profile> =>
    (await api.request<Profile>({ url: API_PATHS.USERS.ME, method: "PATCH", data: fields })).data,
  // Multipart upload of a profile icon. The server stores the image and returns
  // the refreshed profile with profileIcon pointing at the stored URL. Let the
  // browser set the multipart boundary — don't override Content-Type.
  uploadIcon: async (file: File): Promise<Profile> => {
    const data = new FormData();
    data.append("file", file);
    return (await api.request<Profile>({ url: API_PATHS.USERS.ICON, method: "POST", data })).data;
  },
  // Clears profileIcon; the server deletes the stored image too.
  removeIcon: async (): Promise<Profile> =>
    (await api.request<Profile>({ url: API_PATHS.USERS.ICON, method: "DELETE" })).data,
  changePassword: async (body: { currentPassword: string; newPassword: string }): Promise<void> => {
    await api.request<void>({ url: API_PATHS.USERS.PASSWORD, method: "POST", data: body });
  },
  requestEmailChange: async (body: { newEmail: string; password: string }): Promise<void> => {
    await api.request<void>({ url: API_PATHS.USERS.EMAIL, method: "POST", data: body });
  },
  verifyEmailChange: async (body: { otp: string }): Promise<void> => {
    await api.request<void>({ url: API_PATHS.USERS.EMAIL_VERIFY, method: "POST", data: body });
  },
};
